import React from 'react'
import style from './statusItem.module.scss'
import { VegaCard } from '../../../vega/card/Card'
import { VegaIcon } from '../../../vega/icon/Icon'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { FormatType } from '../../../../utils/translation/i18n'
import { PropTypes } from 'prop-types'
import { PaymentStatus } from '../../../../resources/constants/PaymentStatus'

/** Card showing datas of a status in a bank */
const StatusItem = ({ status: { paymentStatus, date } }) => {
	const { statusTranslation } = PaymentStatus[paymentStatus]
	const { t, i18n } = useTranslation()
	const prefixTranslation = 'historyStatus'
	return (
		<VegaCard hasShadow={false} className={cx(style.status, style.card)}>
			<div className={style.titleRow}>
				<VegaIcon name="check" className={cx(style.icon)} />
				<div className={cx(style.title)}>
					{t(prefixTranslation + statusTranslation + 'Title')}
				</div>
			</div>
			<div className={style.detail}>
				{t(prefixTranslation + statusTranslation + 'Subtitle')}
			</div>
			<div className={cx(style.date)}>
				{i18n.format(date, {
					type: FormatType.DATE,
					format: t('historyTimeFormat')
				})}
			</div>
		</VegaCard>
	)
}

StatusItem.propTypes = {
	/** Object containing status date and payment status */
	status: PropTypes.shape({
		paymentStatus: PropTypes.oneOf(Object.keys(PaymentStatus)),
		/** Date of the status */
		date: PropTypes.string
	})
}

export { StatusItem }
